// extracted by mini-css-extract-plugin
export default {"product-report-container":"products_product-report-container__XTFyn"};